import { useDropzone } from 'react-dropzone';
import { ErrorMessage } from 'formik';
import { HiUpload } from 'react-icons/hi';

const FileUploadField = ({
  name = 'fileUrl',
  label = 'Upload File',
  values,
  setFieldTouched,
  setFieldError,
  setFieldValue,
  handleOnUploadFile,
  maxSize = 6,
  allowedTypes = ['application/pdf'],
}) => {
  const byteLimit = maxSize * 1024 * 1024;

  const onDrop = async (acceptedFiles, fileRejections) => {
    if (fileRejections.length > 0) {
      const error = fileRejections[0].errors[0];
      const file = fileRejections[0].file;
      let message = error.message;

      if (error.code === 'file-too-large') {
        const actualSizeMB = (file.size / (1024 * 1024)).toFixed(1);
        message = `File is too large (${actualSizeMB} MB). Max allowed is ${maxSize} MB.`;
      }

      if (error.code === 'file-invalid-type') {
        message = `Unsupported file format. Allowed: ${allowedTypes.join(', ')}`;
      }

      setFieldTouched(name, true, false);
      setFieldError(name, message);
      return;
    }

    const file = acceptedFiles[0];
    const uploaded = await handleOnUploadFile(file);

    if (uploaded) {
      setFieldValue(name, file.name);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize: byteLimit,
    multiple: false,
    accept: allowedTypes.reduce((acc, type) => {
      acc[type] = [];
      return acc;
    }, {}),
  });

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-1">
        {label} <span className="text-red-500">*</span>
      </label>

      <div
        {...getRootProps()}
        className={`w-full h-[100px] border-2 border-dashed rounded-xl px-4 text-center cursor-pointer flex flex-col items-center justify-center bg-white transition-all duration-200 ${isDragActive ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-300 hover:border-gray-400'
          }`}
      >
        <input {...getInputProps()} name={name} />
        <HiUpload className="text-blue-500 text-2xl mb-1" />
        {values[name] ? (
          <div className="text-sm text-gray-700 font-medium">
            <p>
              Uploaded:{' '}
                📄 <span className="text-blue-600 font-semibold">
                  {decodeURIComponent(values[name]?.split('/').pop() || '')
                    .replace(/^\d+[-_]?/, '')
                    .replace(/%20/g, ' ')
                    .replace(/_/g, ' ')
                    .trim()}
                </span>{" "}
            </p>
            <p className="text-xs text-gray-500">(Drop or click to replace)</p>
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            <span className="font-medium">Drag & drop</span> or{' '}
            <span className="text-blue-600 underline">click to upload</span>
          </p>
        )}
      </div>

      <ErrorMessage name={name} component="div" className="text-sm text-red-600 mt-1" />
    </div>
  );
};

export default FileUploadField;
